const multicolumnTabs = document.querySelectorAll(".tab");
const multicolumnTabContent = document.querySelectorAll(".tab-content");

multicolumnTabs.forEach((tab, index) => {
  tab.addEventListener("click", (event) => {
    event.preventDefault();
    multicolumnTabs.forEach((innerTab, index) => {
      if (innerTab != tab) {
        innerTab.classList.remove("active");
      }
    });
    tab.classList.add("active");
    multicolumnTabContent.forEach((tabContent, index) => {
      tabContent.classList.add("hidden");
    });
    let content = tab.dataset.href;
    document
      .querySelector(`.tab-media-content.${content}`)
      .classList.remove("hidden");
    document
      .querySelector(`.tab-text-content.${content}`)
      .classList.remove("hidden");
  });
});
